import { toast } from 'src/components/ui/toast';

export interface ToastServiceOptions {
  message?: string;
  title?: string;
  color?: 'success' | 'info' | 'warning' | 'error';
  /** @deprecated Ignored — toast icons are now determined by type/color. */
  icon?: string;
  persistent?: boolean;
  onAction?: () => void;
  actionLabel?: string;
}

/** @deprecated No-op — sonner works without registration. */
export function registerToastService(
  _fn: (options: ToastServiceOptions) => void,
) {}

const defaultTitles: Record<string, string> = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
  info: 'Info',
};

export function showToastOutsideReact(options: ToastServiceOptions): boolean {
  const {
    message,
    color = 'success',
    persistent,
    onAction,
    actionLabel,
  } = options;

  const title = options.title ?? defaultTitles[color];

  toast({
    title,
    description: message,
    type: color,
    duration: persistent ? Infinity : undefined,
    action:
      onAction && actionLabel
        ? { label: actionLabel, onClick: onAction }
        : undefined,
  });

  return true;
}
